import * as React from 'react';
import Estimate12hCountdown from './components/Estimate-12hCountdownTimer/ItemBiddingEstimate';

type Props = {
    catalogId: number;
    itemId: number;
    onCountdownEnd?: () => void;
    showCountdown?: boolean;
};

const ItemBiddingEstimate = ({ catalogId, itemId, onCountdownEnd, showCountdown = true }: Props) => {
    return (
        <Estimate12hCountdown
            catalogId={catalogId}
            itemId={itemId}
            onCountdownEnd={onCountdownEnd}
            showCountdown={showCountdown}
        />
    );
};

export default ItemBiddingEstimate;
